import { Map as ImmutableMap } from 'immutable';
import { isSucceeded } from '../asyncData/AsyncData';
import useFetchPropertyMetaDataForDataType from './useFetchPropertyMetaDataForDataType';
const useFetchPropertyLabels = (dataType, properties) => {
  const propertyMetaDataMap = useFetchPropertyMetaDataForDataType(dataType, properties);
  if (isSucceeded(propertyMetaDataMap)) {
    return ImmutableMap(properties.map(propertyName => [propertyName, propertyMetaDataMap.data.getIn([propertyName, 'label'], propertyName)]));
  }
  return ImmutableMap(properties.map(propertyName => [propertyName, propertyName]));
};
export default useFetchPropertyLabels;